<template>
  <div class="sidebar-container">
    <!-- User Profile Section -->
    <div class="user-profile" 
         :class="{ 'active': isActive('/user/profile') }"
         @click="navigateToProfile">
      <UserAvatar 
        :src="userAvatar" 
        :name="userName" 
        :size="50"
        class="user-avatar"
      />
      <div class="user-info">
        <h3 class="user-name">{{ userName }}</h3>
        <p class="user-role">{{ userRole }}</p>
      </div>
    </div>

    <!-- Search Bar -->
    <!-- <div class="search-section">
      <div class="search-wrapper">
        <i class="mdi mdi-magnify search-icon"></i>
        <input 
          type="text" 
          placeholder="Search..." 
          class="search-input"
          v-model="searchQuery"
        />
      </div>
    </div> -->

    <!-- Navigation Menu -->
    <nav class="sidebar-nav">
      <ul class="nav-list">
        <li class="nav-item">
          <router-link 
            to="/user/home" 
            class="nav-link"
            :class="{ 'active': isActive('/user/home') }"
          >
            <div class="nav-icon">
              <i class="mdi mdi-home"></i>
            </div>
            <span class="nav-text">Beranda</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link 
            to="/user/event" 
            class="nav-link"
            :class="{ 'active': isActive('/user/event') }"
          >
            <div class="nav-icon">
              <i class="mdi mdi-calendar"></i>
            </div>
            <span class="nav-text">Event</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link 
            to="/user/campaign" 
            class="nav-link"
            :class="{ 'active': isActive('/user/campaign') }"
          >
            <div class="nav-icon">
              <i class="mdi mdi-bullhorn"></i>
            </div>
            <span class="nav-text">Campaign</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link 
            to="/user/points" 
            class="nav-link"
            :class="{ 'active': isActive('/user/points') }"
          >
            <div class="nav-icon">
              <i class="mdi mdi-star"></i>
            </div>
            <span class="nav-text">Points</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link 
            to="/user/pointers-of-the-month" 
            class="nav-link"
            :class="{ 'active': isActive('/user/pointers-of-the-month') }"
          >
            <div class="nav-icon">
              <i class="mdi mdi-trophy"></i>
            </div>
            <span class="nav-text">Pointers of Month</span>
          </router-link>
        </li>

        <li class="nav-item nav-divider">
          <div class="divider-line"></div>
        </li>

        <li class="nav-item">
          <router-link 
            to="/user/faq" 
            class="nav-link"
            :class="{ 'active': isActive('/user/faq') }"
          >
            <div class="nav-icon">
              <i class="mdi mdi-help-circle"></i>
            </div>
            <span class="nav-text">FAQ</span>
          </router-link>
        </li>

        <li class="nav-item">
          <a 
            href="#" 
            class="nav-link"
            @click.prevent="handleSignOut"
          >
            <div class="nav-icon">
              <i class="mdi mdi-logout"></i>
            </div>
            <span class="nav-text">Sign Out</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import AppUserAvatar from './UserAvatar.vue';

export default {
  name: "DashboardSidebar",
  components: {
    UserAvatar: AppUserAvatar
  },
  data() {
    return {
      searchQuery: "",
      userName: "Loading...",
      userRole: "Loading...",
      userAvatar: null, // Will use initials from UserAvatar component
      userId: null
    };
  },
  computed: {
    canAccessCampaign() {
      // Only allow user ID 10828 to access Campaign
      return this.userId === 11379;
    }
  },
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
    
    navigateToProfile() {
      if (this.$route.path !== '/user/profile') {
        this.$router.push('/user/profile').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err);
          }
        });
      }
    },

    fetchUserData() {
      const userDatas = this.$getUserInfo();
      const userId = userDatas.sub?.user_id;
      
      // Set userId for campaign access check
      this.userId = userId;
      
      if (userId) {
        const baseURI = this.$settings.endPoint + "get-user/detail/" + userId;
        
        this.$http
          .get(baseURI, {
            timeout: 10000,
            headers: {
              'AppToken': this.$settings.jwtSecret,
            }
          })
          .then((response) => {
            if (response.data.status === 200) {
              const userData = response.data.datas;
              this.userName = userData.name || "User";
              this.userRole = userData.community?.community || "Member";
              this.userAvatar = userData.image;
              
              // Update localStorage with fresh data
              this.updateLocalStorage(userData);
            } else {
              // Fallback to localStorage data
              this.setUserDataFromLocalStorage(userDatas);
            }
          })
          .catch(error => {
            console.log('Error fetching user data in sidebar:', error);
            // Fallback to localStorage data
            this.setUserDataFromLocalStorage(userDatas);
          });
      } else {
        // Fallback to localStorage if no user_id
        this.setUserDataFromLocalStorage(userDatas);
      }
    },

    setUserDataFromLocalStorage(userDatas) {
      this.userName = userDatas.sub?.name || "User";
      this.userRole = userDatas.sub?.community?.community || "Member";
      this.userAvatar = userDatas.sub?.image;
    },

    updateLocalStorage(userData) {
      try {
        const currentUserData = JSON.parse(localStorage.getItem('userModels'));
        if (currentUserData && currentUserData.sub) {
          // Update the user data in localStorage
          currentUserData.sub = { ...currentUserData.sub, ...userData };
          localStorage.setItem('userModels', JSON.stringify(currentUserData));
        }
      } catch (error) {
        console.log('Error updating localStorage:', error);
      }
    },
    
    handleSignOut() {
      this.$swal({
        title: 'Sign Out',
        text: 'Are you sure you want to sign out?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#ffc107',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, Sign Out',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          // Clear user data and redirect to login
          localStorage.removeItem('userModels');
          localStorage.removeItem('authToken');
          this.$router.push('/login');
        }
      });
    }
  },
  mounted() {
    this.fetchUserData();
    
    // Listen for user data updates
    this.$root.$on('userDataUpdated', () => {
      this.fetchUserData();
    });
  },
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('userDataUpdated');
  }
};
</script>

<style scoped>
.sidebar-container {
  width: 280px;
  height: 100vh;
  background: white;
  border-right: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  overflow-y: auto;
}

/* User Profile Section */
.user-profile {
  padding: 1rem;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin: 1rem;
}

.user-profile:hover {
  background: #f8f9fa;
}

.user-profile.active {
  background: var(--yellow-main);
  color: white;
}

.user-profile.active .user-name {
  color: white;
}

.user-profile.active .user-role {
  color: rgba(255, 255, 255, 0.8);
}

.user-avatar {
  flex-shrink: 0;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.25rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  font-size: 0.85rem;
  color: #6c757d;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Search Section */
.search-section {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #6c757d;
  font-size: 1.1rem;
  z-index: 2;
}

.search-input {
  width: 100%;
  padding: 10px 12px 10px 40px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.search-input:focus {
  outline: none;
  border-color: var(--yellow-soft);
  background: white;
  box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.1);
}

/* Navigation */
.sidebar-nav {
  flex: 1;
  padding: 1rem 0;
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  margin: 0;
  padding: 0px 20px;
}

.nav-divider {
  padding: 1rem 1.5rem;
}

.divider-line {
  height: 1px;
  background: #e9ecef;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  color: #6c757d;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  border-radius: 8px;
}

.nav-link:hover {
  background: #f8f9fa;
  color: #495057;
}

.nav-link.active {
  background: var(--yellow-main);
  color: white;
  font-weight: 500;
  border-radius: 8px;
}

.nav-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nav-icon i {
  font-size: 1.2rem;
}

.nav-text {
  font-size: 0.95rem;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .sidebar-container {
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
  
  .sidebar-container.open {
    transform: translateX(0);
  }
}

/* Scrollbar Styling */
.sidebar-container::-webkit-scrollbar {
  width: 4px;
}

.sidebar-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.sidebar-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.sidebar-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>